module.exports = __webpack_public_path__ + "i18n/es_2888cc08f0c2995d9891d4f907614c0d.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_es.properties
// module id = DOE4
// module chunks = 55